import {createSelector} from 'reselect';
import ExpressType from '../../../enums/ExpressType';
import {getPaymentOptions} from './PaymentOptionSelectors';

export default createSelector(
  [getPaymentOptions],
  paymentOptions => paymentOptions
    .filter(paymentOption => paymentOption.express)
    .map(expressOption => ExpressType[expressOption.name])
    .filter(Boolean),
);
